// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"Loading_loadingContainer__4HrfJ","period":"Loading_period__22kC5","wave":"Loading_wave__1AlLu"};